var map = {
	"./announcement_icon.png": 474,
	"./apy_icon_1.png": 961,
	"./apy_icon_2.png": 962,
	"./arrow-down-blue.svg": 963,
	"./arrow-down-grey.svg": 964,
	"./arrow-right-white.png": 965,
	"./arrow-right.svg": 966,
	"./arrow.png": 475,
	"./big_unicorn.png": 476,
	"./blue-loader.svg": 477,
	"./circle-grey.svg": 967,
	"./circle.svg": 968,
	"./coinbaseWalletIcon.svg": 470,
	"./dropdown-blue.svg": 969,
	"./dropdown.svg": 970,
	"./dropup-blue.svg": 971,
	"./dynamic_icon.png": 478,
	"./ethereum-logo.png": 321,
	"./fallback.png": 322,
	"./fortmaticIcon.png": 472,
	"./harvst.png": 479,
	"./img_fallback.png": 972,
	"./jump_icon.png": 480,
	"./link.svg": 973,
	"./logo.svg": 161,
	"./magnifying-glass.svg": 974,
	"./market_price_icon.png": 975,
	"./menu.svg": 976,
	"./metamask.png": 205,
	"./noise.png": 481,
	"./plus-blue.svg": 977,
	"./plus-grey.svg": 978,
	"./portisIcon.png": 473,
	"./question-mark.svg": 979,
	"./question.svg": 980,
	"./spinner.svg": 981,
	"./token-list/lists-dark.png": 982,
	"./token-list/lists-light.png": 983,
	"./token-logo.png": 482,
	"./trustWallet.png": 984,
	"./unstake.png": 483,
	"./vault-coins/dai.png": 409,
	"./vault-coins/elf.png": 414,
	"./vault-coins/eth.png": 415,
	"./vault-coins/sashimi.svg": 416,
	"./vault-coins/usdc.svg": 410,
	"./vault-coins/usdt.svg": 411,
	"./vault-coins/wbtc.svg": 412,
	"./vault-coins/yfi.png": 413,
	"./waitting.png": 985,
	"./walletConnectIcon.svg": 471,
	"./x.svg": 986,
	"./xl_uni.png": 484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 423;